import angular from 'angular';

const services = angular.module('applicationModule.webModulesServices', []);

services.factory('Webmodules', ['WebmodulesAPI', function (WebmodulesAPI) {
    'use strict';

    var checkFiles = function (upload) {
        var files = [];
        var names = [];
        angular.forEach(upload, function (val, key) {
            if (angular.isDefined(val)) {
                files.push(val);
                names.push(key);
            }
        });

        return {files: files, names: names};
    };

    return {
        all: (appId, pageId, layout) => {
            return WebmodulesAPI.all(appId, pageId, layout)
                .then(response => response.data);
        },
        get: (id, appId) => {
            return WebmodulesAPI.get(id, appId);
        },
        save: (data, uploads, editMode) => {
            let files = [];
            if (angular.isDefined(uploads)) {
                files = checkFiles(uploads);
            }

            return WebmodulesAPI.store(data, editMode, files);
        },
        remove: (id, appId) => {
            return WebmodulesAPI.remove(id, appId);
        },
        create: (params) => {
            return WebmodulesAPI.create(params)
                .then(response => response.data);
        },
        changeOrder: (data) => {
            return WebmodulesAPI.changeOrder(data);
        },
        list: (app_id) => {
            return WebmodulesAPI.list(app_id)
                .then(response => response.data.modules);
        },
        listToMenu: (app_id) => {
            return WebmodulesAPI.listToMenu(app_id)
                .then(response => response.data);
        },
        containers: (app_id, page_id) => {
            return WebmodulesAPI.containers(app_id, page_id)
                .then(response => response.data.containers);
        },
        add: (data, upload) => {
            return WebmodulesAPI.add(data, upload);
        },
        autocomplete: (appId, moduleId, text) => {
            return WebmodulesAPI.autocomplete(appId, moduleId, text);
        },
        getTemplates: () => {
            return WebmodulesAPI.getTemplates();
        },
        getTemplateInputs: (template) => {
            return WebmodulesAPI.getTemplateInputs(template);
        }
    };
}]);

services.service('WebmodulesAPI', ['$http', 'AppsoupAPI', 'Upload', function ($http, AppsoupAPI, Upload) {
    'use strict';

    const API_URL = `${AppsoupAPI.API_URL}/app/web-modules/`;

    this.all = function (appId, pageId, layout) {
        return $http.get(API_URL, {params: {application_id: appId, parent_id: pageId, layout: layout}});
    };

    this.get = (id) => {
        return $http.get(`${API_URL}${id}`);
    };

    this.store = (data, editMode, files) => {
        if (editMode) {
            const newfields = angular.extend(data, {_method: 'PUT'});

            return Upload.upload({
                url: `${API_URL}${data.id}`,
                method: 'POST',
                sendObjectsAsJsonBlob: false,
                fields: newfields,
                file: files.files,
                fileFormDataName: files.names
            });
        } else {
            return Upload.upload({
                url: API_URL,
                method: 'POST',
                sendObjectsAsJsonBlob: false,
                fields: data,
                file: files.files,
                fileFormDataName: files.names
            });
        }
    };

    this.remove = (id) => {
        return $http.delete(`${API_URL}${id}`);
    };

    this.create = (params) => {
        return $http.get(`${API_URL}create`, {params});
    };

    this.changeOrder = (data) => {
        const url = `${API_URL}change-order/`;
        return $http.post(url, data);
    };

    this.list = (appId) => {
        return $http.get(`${API_URL}list/${appId}`);
    };

    this.listToMenu = (appId) => {
        return $http.get(`${API_URL}list-to-menu/${appId}`);
    };

    this.containers = (appId, pageId) => {
        return $http.get(`${API_URL}containers/${appId}/${pageId}`);
    };

    this.add = (data, upload) => {
        return $http.post(`${API_URL}add`, data, upload);
    };

    this.autocomplete = (appId, moduleId, text) => {
        return $http.get(`${API_URL}autocomplete/${appId}/${moduleId}/${text}`);
    };

    this.getTemplates = () => {
        return $http.get(`${API_URL}templates/get`);
    };

    this.getTemplateInputs = (template) => {
        return $http.get(`${API_URL}inputs/get`, {params: {template}});
    };
}]);

export default services;
